const Tabs = () => ({
  activateTab(tab) {
    const tabControls = tab.getAttribute('aria-controls');
    document.getElementById(tabControls).removeAttribute('hidden');

    tab.removeAttribute('tabindex');
    tab.setAttribute('aria-selected', 'true');
  },

  deactivateTabs() {
    this.tabs.forEach((tab, tabIndex) => {
      this.panels[tabIndex].setAttribute('hidden', 'hidden');
      tab.setAttribute('tabindex', '-1');
      tab.setAttribute('aria-selected', 'false');
    });
  },

  bindControlEvents() {
    this.tabs.forEach((tab, tabIndex) => {
      tab.addEventListener('click', (event) => {
        event.preventDefault();

        const clickTarget = event.currentTarget;

        this.deactivateTabs();
        this.activateTab(clickTarget);
      });

      // Handle keydown on tabs
      tab.addEventListener('keydown', (event) => {
        event.preventDefault();

        const firstTab = this.tabs[0];
        const lastTab = this.tabs[this.tabs.length - 1];

        switch (event.key) {
          // When focus is on an tab, moves focus to the last tab.
          case 'End': {
            event.preventDefault();

            lastTab.focus();
            this.deactivateTabs();
            this.activateTab(lastTab);
            break;
          }
          // When focus is on an tab, moves focus to the first tab.
          case 'Home': {
            event.preventDefault();

            firstTab.focus();
            this.deactivateTabs();
            this.activateTab(firstTab);
            break;
          }
          // Up and down are in keydown
          // because we need to prevent page scroll >:)
          case 'ArrowUp':
          case 'ArrowDown': {
            this.determineOrientation(event, tabIndex);
            break;
          }
          default: {
            break;
          }
        }
      });

      // Handle keyup on tabs
      tab.addEventListener('keyup', (event) => {
        event.preventDefault();

        switch (event.key) {
          case 'ArrowRight':
          case 'ArrowLeft': {
            this.determineOrientation(event, tabIndex);
            break;
          }
          default: {
            break;
          }
        }
      });
    });
  },

  // When a lists aria-orientation is set to vertical,
  // only up and down arrow should function.
  // In all other cases only left and right arrow function.
  determineOrientation(event, tabIndex) {
    const { key } = event;
    const vertical = this.list.getAttribute('aria-orientation') === 'vertical';

    if (vertical) {
      if (key === 'ArrowUp' || key === 'ArrowDown') {
        event.preventDefault();
        this.switchTabOnArrowPress(key, tabIndex);
      }
    } else if (key === 'ArrowLeft' || key === 'ArrowRight') {
      event.preventDefault();
      this.switchTabOnArrowPress(key, tabIndex);
    }
  },

  // Either focus the next, previous, first, or last tab
  // depening on key pressed
  switchTabOnArrowPress(key, tabIndex) {
    const tabCount = this.tabs.length;

    switch (key) {
      case 'ArrowUp':
      case 'ArrowRight': {
        const newIndex = (tabIndex + tabCount + 1) % tabCount;
        const nextTab = this.tabs[newIndex];
        nextTab.focus();
        this.deactivateTabs();
        this.activateTab(nextTab);
        break;
      }
      case 'ArrowDown':
      case 'ArrowLeft': {
        const newIndex = (tabIndex + tabCount - 1) % tabCount;
        const previousTab = this.tabs[newIndex];
        previousTab.focus();
        this.deactivateTabs();
        this.activateTab(previousTab);
        break;
      }
      default: {
        break;
      }
    }
  },

  init() {
    this.list = this.$root.querySelector('.tabs__list');
    this.tabs = this.$root.querySelectorAll('.tabs__tab');
    this.panels = this.$root.querySelectorAll('.tabs__panel');

    this.bindControlEvents();
  }
});

export default Tabs;
